// extracted by mini-css-extract-plugin
module.exports = {"brandStory":"brandStory_brandStory__2PfCr"};